import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { jwtDecode } from 'jwt-decode';
import { mockUser, mockToken } from '../../services/mockData';

// Check if token exists and is valid
const token = localStorage.getItem('token');
let user = null;

if (token) {
  try {
    // Decode the token to get user info
    user = jwtDecode(token);
    
    // Check if token is expired
    const currentTime = Date.now() / 1000;
    if (user.exp < currentTime) {
      localStorage.removeItem('token');
      user = null;
    }
  } catch (error) {
    localStorage.removeItem('token');
    user = null;
  }
}

const initialState = {
  user,
  token,
  isAuthenticated: !!user,
  loading: false,
  error: null,
};

// Login thunk (mocked)
export const login = createAsyncThunk(
  'auth/login',
  async (credentials, { rejectWithValue }) => {
    try {
      // Simulate API delay
      await new Promise(resolve => setTimeout(resolve, 1000));
      
      // Simple mock validation
      if (credentials.email === 'admin@salovare.com' && credentials.password === 'password') {
        // Store token in localStorage
        localStorage.setItem('token', mockToken);
        
        return { user: mockUser, token: mockToken };
      } else {
        return rejectWithValue('Invalid email or password');
      }
    } catch (error) {
      return rejectWithValue('Login failed');
    }
  }
);

// Logout thunk
export const logout = createAsyncThunk('auth/logout', async () => {
  localStorage.removeItem('token');
  return null;
});

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(login.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(login.fulfilled, (state, action) => {
        state.loading = false;
        state.isAuthenticated = true;
        state.user = action.payload.user;
        state.token = action.payload.token;
      })
      .addCase(login.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(logout.fulfilled, (state) => {
        state.isAuthenticated = false;
        state.user = null;
        state.token = null;
      });
  },
});

export const { clearError } = authSlice.actions;

export const selectAuth = (state) => state.auth;
export const selectUser = (state) => state.auth.user;
export const selectIsAuthenticated = (state) => state.auth.isAuthenticated;

export default authSlice.reducer; 